import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { SiteNav } from './SiteNav';
import { SiteFooter } from './SiteFooter';
/**
 * Scrolls the window to the top whenever the route pathname changes.
 * React Router v6 does not do this by default.
 */
function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      // Defer to next tick so the target element is mounted
      requestAnimationFrame(() => {
        const el = document.getElementById(hash.slice(1));
        if (el) {
          el.scrollIntoView({
            block: 'start'
          });
          return;
        }
        window.scrollTo(0, 0);
      });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}
export function Layout() {
  return <div className="min-h-screen flex flex-col bg-bodybg font-sans text-[#E5E5E5] antialiased" data-id="element-114" data-mp="3kmle9f8vn8tl">
      <ScrollToTop data-id="element-115" data-mp="3fnh5gppv7d3s" />
      <SiteNav data-id="element-116" data-mp="3fo0ns7jfg3ic" />
      <main className="flex-1" data-id="element-117" data-mp="3fmftmj10yml0">
        <Outlet data-id="element-118" data-mp="1isf0wmeuxbyh" />
      </main>
      <SiteFooter data-id="element-119" data-mp="1ir410xoj8ocn" />
    </div>;
}